//Action Imports
import { 
    BUSINESS_LOGIN_START, 
    BUSINESS_LOGIN_SUCCESS, 
    BUSINESS_LOGIN_FAILED, 
    VOLUNTEER_LOGIN_START, 
    VOLUNTEER_LOGIN_SUCCESS, 
    VOLUNTEER_LOGIN_FAILED, 
    REGISTER_BUSINESS_START, 
    REGISTER_BUSINESS_SUCCESS, 
    REGISTER_BUSINESS_FAILED, 
    REGISTER_VOLUNTEER_START, 
    REGISTER_VOLUNTEER_SUCCESS, 
    REGISTER_VOLUNTEER_FAILED,
    ADD_FOOD_START,
    ADD_FOOD_SUCCESS,
    ADD_FOOD_FAILED,
    GET_FOODITEMS_START,
    GET_FOODITEMS_SUCCESS,
    GET_FOODITEMS_FAILED, 
    UPDATE_FOODITEM_START,
    UPDATE_FOODITEM_SUCCESS,
    UPDATE_FOODITEM_FAILED,
    DELETE_FOODITEM_START,
    DELETE_FOODITEM_SUCCESS,
    DELETE_FOODITEM_FAILED,    
} from '../actions'


//Initial State Object
const initialState = {
    payload: [],
    isLoading: false,
    errorMessage: null,
    loggedUser: [],
    newFoodObject:[],
    allFoodItems:[],
    deletingItem:false,
}

//The Single Reducer for the whole app
export const reducer = (state=initialState, action) => {
    switch(action.type){
        case BUSINESS_LOGIN_START:
            return {
                ...state,
                isLoading: true,
            }
        case BUSINESS_LOGIN_SUCCESS:
            return {
                ...state,
                isLoading:false,
                payload: action.payload,
                errorMessage: null,
                loggedUser: action.payload.user
            }
        case BUSINESS_LOGIN_FAILED:
            return {
                ...state, 
                isLoading:false,
                errorMessage: action.payload,
            }
        case VOLUNTEER_LOGIN_START:
            return {
                ...state,
                isLoading:true,
            }
        case VOLUNTEER_LOGIN_SUCCESS:
            return {
                ...state,
                isLoading:false,
                payload: action.payload,
                errorMessage: null,
                loggedUser: action.payload.user
            }
        case VOLUNTEER_LOGIN_FAILED:
            return {
                ...state,
                isLoading:false,
                errorMessage: action.payload,
            }
        case REGISTER_BUSINESS_START:
            return {
                ...state,
                isLoading:true,
            }
        case REGISTER_BUSINESS_SUCCESS:
            return {
                ...state,
                isLoading:false,
                payload: action.payload,
                errorMessage: null,
            }
        case REGISTER_BUSINESS_FAILED:
            return {
                ...state,
                isLoading:false,
                errorMessage: action.payload,
            }
        case REGISTER_VOLUNTEER_START:
            return {
                ...state,
                isLoading:true,
            }
        case REGISTER_VOLUNTEER_SUCCESS:
            return {
                ...state,
                isLoading:false,
                payload: action.payload,
                errorMessage: null,
            }
        case REGISTER_VOLUNTEER_FAILED:
            return {
                ...state,
                isLoading:false,
                errorMessage: action.payload,
            }
        case ADD_FOOD_START:
            return {
                ...state,
                isLoading:true,
            }
        case ADD_FOOD_SUCCESS:
            return {
                ...state,
                isLoading:false,
                newFoodObject: action.payload,
                errorMessage: null,
            }
        case ADD_FOOD_FAILED:
            return {
                ...state,
                isLoading:false,
                errorMessage: action.payload,
            }
        case GET_FOODITEMS_START:
            return {
                ...state,
                isLoading:true,
            }
        case GET_FOODITEMS_SUCCESS:
            return {
                ...state,
                isLoading:false,
                allFoodItems: action.payload,
                errorMessage: null,
            }
        case GET_FOODITEMS_FAILED:
            return {
                ...state,
                isLoading:false,
                errorMessage: action.payload,
            }
        case UPDATE_FOODITEM_START:
            return {
                ...state,
                isLoading:true,
            }
        case UPDATE_FOODITEM_SUCCESS:
            return {
                ...state,
                isLoading:false,
                errorMessage:null,
            }
        case UPDATE_FOODITEM_FAILED:
            return {
                ...state,
                isLoading:false,
                errorMessage: action.payload
            }
        case DELETE_FOODITEM_START:
            return {
                ...state,
                deletingItem:true,
            }
        case DELETE_FOODITEM_SUCCESS:
            return {
                ...state,
                deletingItem:false,
                allFoodItems: action.payload,
            }
        case DELETE_FOODITEM_FAILED:
            return {
                ...state,
                deletingItem:false,
                error: action.payload,
            }
        default:
            return state
    }
}